<template>
  <div>
    <div class="row">
      <div class="col" style=" margin-bottom: 15px;">
        <!-- <button  @click="scriptCreaUtenti()" style="background-color:none;">scriptCreaUtenti</button> -->
        <!--<span class="float-left">
          <router-link :to="'/'"><button class="btn" type="button" style="background:#00467f">Crea</button></router-link>
        </span>-->
        <b-button @click="modalShow = !modalShow" class="float-left" style="background:#00467f;">Crea Utente</b-button>
        <b-modal v-model="modalShow"  size="lg">
          <template #modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm"  style="background:#00467f;" @click="close()">X</b-button>
            <h3 style="color:black;text-align:center">Crea Nuovo Utente</h3>
          </template>
          <template>
            <form><!--{EMAIL,USERNAME,PASSWORD,NOME,COGNOME,LIVELLO} -->
              <label for="email"><strong>EMAIL*</strong></label>
              <input class="form-control" type="email" placeholder="email" name="email" v-model="create_email">
              <label for="username"><strong>USERNAME*</strong></label>
              <input class="form-control" type="text" placeholder="username" name="username" v-model="create_username">
              <label for="password"><strong>PASSWORD*</strong></label>
              <input class="form-control" type="text" placeholder="password" name="password" v-model="create_password">
              <label for="name"><strong>NOME*</strong></label>
              <input class="form-control" type="text" placeholder="name" name="name" v-model="create_name">
              <label for="surname"><strong>COGNOME*</strong></label>
              <input class="form-control" type="text" placeholder="surname" name="surname" v-model="create_surname">
              <label for="level" style="margin-top:10px"><strong>LIVELLO*</strong></label>
              <select name="level" v-model="create_level" style="margin-left:10px; width:30px">
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
              <!--<input class="form-control" type="number" placeholder="level" name="level" v-model="create_level" min="1" max="5" v-on:keyup.enter="createUser()">-->
            </form> 
          </template>
          
          <template #modal-footer="{ cancel }">
            <span style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">CHIUDI</b-button></span>
            <span style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="createUser()">SALVA</b-button></span>
          </template>
        </b-modal>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3 style="color:#00467f">Gestione utenti</h3>
        <card class="card">
          <div class="table-responsive">
            <!--<h3>Gestione utenti</h3>-->
            <h4><strong>UTENTI CONFCOMMERCIO</strong></h4>
            <h5>UTENTI AMMINISTRATORI</h5>
            <table class="table tablesorter" id="tabella" style="text-align: center">
              <thead>
                <tr>
                  <th>Nome utente</th>
                  <th>Livello</th>
                  <th>Sede</th>
                  <th>Informazioni</th>
                  <th>Pratiche</th>
                  <th>Log</th>
                </tr>
              </thead>
              <tbody>
                <tr class="row-color"  v-for="valori in level1_users" v-bind:key="valori.ID"><!-- -->
                  <td>{{valori.USERNAME}}</td>
                  <td>{{valori.LIVELLO}}</td>
                  <td>{{valori.SEDE}}</td>
                  <td><button @click="showInfo = !showInfo" class="info-button" v-on:click="getUserInfo(valori.ID)" style="background-color:none;"><i class="fa fa-info-circle" style="color:#00467f"></i></button></td>
                  <td><router-link :to="'/pratiche-singolo?id='+valori.ID+'&username='+valori.USERNAME" target="_blank"><i class="tim-icons icon-zoom-split" style="color:#00467f"></i></router-link></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <h5>UTENTI ADMIN ASCOM</h5>
            <table class="table tablesorter" id="tabella" style="text-align: center">
              <thead>
                <tr>
                  <th>Nome utente</th>
                  <th>Livello</th>
                  <th>Sede</th>
                  <th>Informazioni</th>
                  <th>Pratiche</th>
                </tr>
              </thead>
              <tbody>
                <tr class="row-color"  v-for="valori in level2_users" v-bind:key="valori.ID"><!-- -->
                  <td>{{valori.USERNAME}}</td>
                  <td>{{valori.LIVELLO}}</td>
                  <td>{{valori.SEDE}}</td>
                  <td><button @click="showInfo = !showInfo" class="info-button" v-on:click="getUserInfo(valori.ID)" style="background-color:none;"><i class="fa fa-info-circle" style="color:#00467f"></i></button></td>
                  <td><router-link :to="'/pratiche-singolo?id='+valori.ID+'&username='+valori.USERNAME" target="_blank"><i class="tim-icons icon-zoom-split" style="color:#00467f"></i></router-link></td>
                </tr>
              </tbody>
            </table>
            <h5>UTENTI ASCOM</h5>
            <table class="table tablesorter" id="tabella" style="text-align: center">
              <thead>
                <tr>
                  <th>Nome utente</th>
                  <th>Livello</th>
                  <th>Sede</th>
                  <th>Informazioni</th>
                  <th>Pratiche</th>
                </tr>
              </thead>
              <tbody>
                <tr class="row-color"  v-for="valori in level3_users" v-bind:key="valori.ID"><!-- -->
                  <td>{{valori.USERNAME}}</td>
                  <td>{{valori.LIVELLO}}</td>
                  <td>{{valori.SEDE}}</td>
                  <td><button @click="showInfo = !showInfo" class="info-button" v-on:click="getUserInfo(valori.ID)" style="background-color:none;"><i class="fa fa-info-circle" style="color:#00467f"></i></button></td>
                  <td><router-link :to="'/pratiche-singolo?id='+valori.ID+'&username='+valori.USERNAME" target="_blank"><i class="tim-icons icon-zoom-split" style="color:#00467f"></i></router-link></td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
        <card class="card">
          <div class="table-responsive">
            <h4><strong>UTENTI SATEC</strong></h4>
            <div v-if="level4_users.length != 0">
                <h5>UTENTI ADMIN SATEC</h5>
                <table class="table tablesorter" id="tabella" style="text-align: center">
                <thead>
                    <tr>
                    <th>Nome utente</th>
                    <th>Livello</th>
                    <th>Sede</th>
                    <th>Informazioni</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="row-color"  v-for="valori in level4_users" v-bind:key="valori.ID"><!-- -->
                    <td>{{valori.USERNAME}}</td>
                    <td>{{valori.LIVELLO}}</td>
                    <td>{{valori.SEDE}}</td>
                    <td><button @click="showInfo = !showInfo" class="info-button" v-on:click="getUserInfo(valori.ID)" style="background-color:none;"><i class="fa fa-info-circle" style="color:#00467f"></i></button></td>
                    </tr>
                </tbody>
                </table>
            </div>
            <h5>UTENTI SATEC</h5>
            <table class="table tablesorter" id="tabella" style="text-align: center">
              <thead>
                <tr>
                  <th>Nome utente</th>
                  <th>Livello</th>
                  <th>Sede</th>
                  <th>Informazioni</th>
                </tr>
              </thead>
              <tbody>
                <tr class="row-color"  v-for="valori in level5_users" v-bind:key="valori.ID"><!-- -->
                  <td>{{valori.USERNAME}}</td>
                  <td>{{valori.LIVELLO}}</td>
                  <td>{{valori.SEDE}}</td>
                  <td><button @click="showInfo = !showInfo" class="info-button" v-on:click="getUserInfo(valori.ID)" style="background-color:none;"><i class="fa fa-info-circle" style="color:#00467f"></i></button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
      <!--<div class="col">
        <card class="card">
          <p style="margin:25px">qualcosa<br>
              ...</p>
        </card>
      </div>-->

      <!-- POPUPs-->
      <b-modal v-model="showInfo"  size="lg">
        <template #modal-header="{ close }">
          <!-- Emulate built in modal header close button action -->
          <b-button size="sm"  style="background:#00467f;" @click="close()">X</b-button>
          <h3 style="color:black">Informazioni Utente</h3>
        </template>
        <template>
           <form><!--{EMAIL,USERNAME,PASSWORD,NOME,COGNOME,LIVELLO} -->
              <div class="row">
                <div class="col"><label for="email"><strong>EMAIL </strong></label>
              <input class="form-control" type="email" placeholder="email" name="email" v-model="email"></div>
                <div class="col">
                  <label for="level"><strong>LIVELLO</strong></label>
                  <select name="level" v-model="level" style="margin-left:10px; width:30px">
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label for="username"><strong>USERNAME</strong></label>
                  <input class="form-control" type="text" placeholder="username" name="username" v-model="username">
                </div>
                <div class="col">
                  <label for="name"><strong>SEDE</strong></label>
                  <input class="form-control" type="text" placeholder="sede" name="sede" v-model="sede">
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label for="name"><strong>NOME</strong></label>
                  <input class="form-control" type="text" placeholder="name" name="name" v-model="name">
                </div>
                <div class="col">
                  <label for="surname"><strong>COGNOME</strong></label>
                  <input class="form-control" type="text" placeholder="surname" name="surname" v-model="surname">
                </div>
              </div>
              <div class="row" style="margin-top:25px">
                <h4 style="color:#00467f;margin-left:15px"><strong>MODIFICA PASSWORD</strong></h4>
              </div>
              <div class="row">
                <div class="col">
                  <label for="password"><strong>PASSWORD</strong></label>
                  <input class="form-control" type="text" placeholder="password" name="password" v-model="password1">
                </div>
                <div class="col">
                  <label for="password"><strong>CONFERMA PASSWORD</strong></label>
                  <input class="form-control" type="text" placeholder="password" name="password" v-model="password2">
                </div>
              </div>
            </form> 
        </template>
        <template #modal-footer="{ cancel }">
          <span style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">CHIUDI</b-button></span>
          <span style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="updateUserInfo()">SALVA MODIFICHE</b-button></span>
        </template>
      </b-modal>

      <!-- -->
      <b-modal v-model="showCheckData"  size="md">
        <template #modal-header="{ close }">
            <b-button size="sm"  style="background:#00467f;" @click="close()">X</b-button>
          </template>
        <template>
          <h3 style="color:black; text-align:center; margin-top:15px">Compilare tutti i campi!!</h3>
        </template>
        <template #modal-footer="{ cancel }">
          <span style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()" v-on:click="cancelCheckData()">CHIUDI</b-button></span>
          <!--<span style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="ok()">OK</b-button></span>-->
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
//import moment from 'moment';
import Card from "../components/Cards/Card.vue";
import Modal from "@/components/Modal.vue";
import Services from '@/services/Services';
import AmministrazioneServices from '@/services/AmministrazioneServices';

export default {
  components: {
    Card,
    Modal,
  },

  data() {
    return {
      //{EMAIL,USERNAME,PASSWORD,NOME,COGNOME,LIVELLO} 
      //per creare utente
      create_email: null,
      create_username: null,
      create_password: null,
      create_name: null,
      create_surname: null,
      create_level: null,
      //per vedere info
      email: null,
      username: null,
      password1: null,
      password2: null,
      name: null,
      surname: null,
      level: null,
      sede: null,
      modalShow: false,
      token_response: null,
      user_livello: "",

      allUsers: [],
      level1_users: [],
      level2_users: [],
      level3_users: [],
      level4_users: [],
      level5_users: [],
      allSedi: [],
      infoUtente: [],

      showInfo: false,
      createUser_response: null,
      showCheckData: false,

      creareUtenti: [
        // { 'FirstName': 'Adele', 'LastName': ' Diana', 'Email': ' adele.diana@confcom.it','Password': '#MvN$FgWt3Gmm$8j' },
        
        { 'FirstName': 'Alberto', 'LastName': ' Casazza', 'Email': ' alberto.casazza@confcom.it', 'Password': 'u941wJOt?YAAJ)VF' },
        { 'FirstName': 'Alessandro', 'LastName': ' Scatamburlo', 'Email': ' alessandro.scatamburlo@confcom.it', 'Password':'pKsill(#jkeG=-cY' },
        { 'FirstName': 'Alessandro', 'LastName': ' Cattelan', 'Email': ' alessandro.cattelan@confcom.it', 'Password': '1oznDaxV9m*32LdH' },
        { 'FirstName': 'Alida', 'LastName': ' Busatto','Email': ' alida.busatto@confcom.it', 'Password': 'rm+H3o0YGp_R+Jj' },
        { 'FirstName': 'Andrea','LastName': ' Tommasi', 'Email': ' andrea.tommasi@confcom.it', 'Password': 'i79kZgmq)yHDm#c' },
        { 'FirstName': 'Andrea', 'LastName': ' Pez', 'Email': ' andrea.pez@confcom.it', 'Password': 'bABiobLk+=@1@fmS' },
        { 'FirstName': 'Andrea','LastName': ' Benetazzo', 'Email': ' andrea.benetazzo@confcom.it', 'Password': 'mDwhJ0Ysc+7GCLs6' },
        { 'FirstName': 'Anna', 'LastName': ' Weindelmayer', 'Email': ' anna.weindelmayer@confcom.it', 'Password': '16?Zw(7ZB2PK!qiE' },
        { 'FirstName': 'Anna', 'LastName': ' Ganz', 'Email': ' anna.ganz@confcom.it', 'Password': ')kvH4GLJdv11p2=Q' },
        { 'FirstName': 'Annamaria', 'LastName': ' Drigo', 'Email': ' annamaria.drigo@confcom.it', 'Password': ' j&s=v!-iDx&XlBO' },
        { 'FirstName': 'Antonella', 'LastName': ' Toffolo', 'Email': ' antonella.toffolo@confcom.it', 'Password': 'ibru?ZwI#6&Fxh+' },
        { 'FirstName': 'Antonella', 'LastName': ' Maso', 'Email': ' antonella.maso@confcom.it', 'Password': 'f`(z0N*&uj!V_7H' },
        { 'FirstName': 'APItest', 'LastName': ' test', 'Email': ' apitest.test@confcom.it', 'Password': 'Pk4cEqBWBM!+2ze' },
        { 'FirstName': 'Arianna', 'LastName': ' Pachi','Email': ' arianna.pachi@confcom.it', 'Password': 'uskf=+=W+2ASsIb?' },
        { 'FirstName': 'Barbar', 'LastName': ' Iop', 'Email': ' barbar.iop@confcom.it', 'Password': '6geEx7ocuE7&1k93' },
        { 'FirstName': 'Barbara', 'LastName': ' Folco', 'Email': ' barbara.folco@confcom.it', 'Password': ' uBoUEqLwafPT(w' },
        { 'FirstName': 'Barbara', 'LastName': ' Lana', 'Email': ' barbara.lana@confcom.it', 'Password': '-5B*j/&BDgl-h)*Z' },
        { 'FirstName': 'Beatrice', 'LastName': ' Scuotto', 'Email': ' beatrice.scuotto@confcom.it', 'Password': 'yq1=b)&&nJaZDsmE' },
        { 'FirstName': 'Beatrice', 'LastName': ' Collauto', 'Email': ' beatrice.collauto@confcom.it', 'Password': 'YM4cGsw%hBT*O!K0' },
        { 'FirstName': 'Bertilla', 'LastName': ' Brava', 'Email': ' bertilla.brava@confcom.it', 'Password': 'qfA4E@Wqf=+wy4SG' },
        { 'FirstName': 'Bruna', 'LastName': ' Tolardo', 'Email': ' bruna.tolardo@confcom.it', 'Password': 'dc%cS4e0PvU5iq' },
        { 'FirstName': 'Bruno', 'LastName': ' Penzo', 'Email': ' bruno.penzo@confcom.it', 'Password': '@J(FGc)OK2t#127' },
        { 'FirstName': 'Carla', 'LastName': ' Moro', 'Email': ' carla.moro@confcom.it', 'Password': 'r?Cm+@D6zKJPiEq' },
        { 'FirstName': 'Caterina', 'LastName': ' Squillaci', 'Email': ' caterina.squillaci@confcom.it', 'Password': '9=T%1@D?*pb#1Jb-' },
        { 'FirstName': 'Cecilia', 'LastName': ' Dotta', 'Email': ' cecilia.dotta@confcom.it', 'Password': ' Ai$yAFiklz%!tzqt' },
        { 'FirstName': 'Chiara', 'LastName': ' Farisatto', 'Email': ' chiara.farisatto@confcom.it', 'Password': ' g?@?oHvZpFvz(+yN' },
        { 'FirstName': 'Chiara', 'LastName': ' Frasson', 'Email': ' chiara.frasson@confcom.it', 'Password': 'clln?=Fj78tQAmMJ' },
        { 'FirstName': 'Chiara', 'LastName': ' Vangelista', 'Email': ' chiara.vangelista@confcom.it', 'Password': 'Ky!qBxdfmLPi/+K0' },
        { 'FirstName': 'Claudia', 'LastName': ' Stefanel', 'Email': ' claudia.stefanel@confcom.it', 'Password': 'KJ7S4LPvw+Oz=%JJ' },
        { 'FirstName': 'Consuelo', 'LastName': ' Vescovi', 'Email': ' consuelo.vescovi@confcom.it', 'Password': '0-1NLy-)Iqi-vq5_' },
        { 'FirstName': 'Cristina', 'LastName': ' Basso', 'Email': ' cristina.basso@confcom.it', 'Password': '$__H)XbYvMt4E%2?' },
        { 'FirstName': 'Cristina', 'LastName': ' Marson', 'Email': ' cristina.marson@confcom.it', 'Password': 'aKJ8o0&eIFiU)YQx' },
        { 'FirstName': 'Daniela', 'LastName': ' Davanzo', 'Email': ' daniela.davanzo@confcom.it', 'Password': 'gji)1B(@(8QKapb?' },
        { 'FirstName': 'Daniela', 'LastName': ' Lucio', 'Email': ' daniela.lucio@confcom.it', 'Password': 'Lg4%8RCg6=awUqaU' },
        { 'FirstName': 'Daniela', 'LastName': ' Poletto', 'Email': ' daniela.poletto@confcom.it', 'Password': '&r6DVU/L8(eN=a3w' },
        { 'FirstName': 'Danilo', 'LastName': ' De Nardi', 'Email': ' danilo.denardi@confcom.it', 'Password': 'dgOJow)=L)$cp3/s' },
        { 'FirstName': 'Dario', 'LastName': ' Corradi', 'Email': ' dario.corradi@confcom.it', 'Password': 'j4J/daDJFcjp?AGU' },
        { 'FirstName': 'David', 'LastName': ' Borrelli', 'Email': ' david.borrelli@confcom.it', 'Password': 'HI1CzOs?!i=0MXxt' },
        { 'FirstName': 'Davide', 'LastName': ' Pasqual', 'Email': ' davide.pasqual@confcom.it', 'Password': '#Z@A341lppk@T_5' },
        { 'FirstName': 'Davide', 'LastName': ' Pasqual', 'Email': ' davide.pasqual@confcom.it', 'Password': 'Y)nP9lu*Sl0-J4EV' },
        { 'FirstName': 'Desara', 'LastName': ' Marku', 'Email': ' desara.marku@confcom.it', 'Password': 'uf2rtoO0uIrSyyZq' },
        { 'FirstName': 'Diana', 'LastName': ' Fagotto', 'Email': ' diana.fagotto@confcom.it', 'Password': 'wXF)wnn2cZ-V)mg' },
        { 'FirstName': 'Donatella', 'LastName': ' Dainese', 'Email': ' donatella.dainese@confcom.it', 'Password': 'jpF(/AcgpCyQbJ5Y' },
        { 'FirstName': 'Donatella', 'LastName': ' Gallo', 'Email': ' donatella.gallo@confcom.it', 'Password': ' __NT$pXQf&@BX!O' },
        { 'FirstName': 'Donatella', 'LastName': ' Bruso', 'Email': ' donatella.bruso@confcom.it', 'Password': 'sm/Nhm&)Q%oc9#e*' },
        { 'FirstName': 'Elena', 'LastName': ' Santoriello', 'Email': ' elena.santoriello@confcom.it', 'Password': 'c$&WJx#p5x#NNln' },
        { 'FirstName': 'Elena', 'LastName': ' Foresto', 'Email': ' elena.foresto@confcom.it', 'Password': 'qo7*pq@Is)P%qY8@' },
        { 'FirstName': 'Elena', 'LastName': ' Bordignon', 'Email': ' elena.bordignon@confcom.it', 'Password': 'Z?TEvfF3v7Dmfhk' },
        { 'FirstName': 'Elena', 'LastName': ' Basso', 'Email': ' elena.basso@confcom.it', 'Password': '(GUu@B(1?(xQd$YC' },
        { 'FirstName': 'Elena', 'LastName': ' Fiorindo', 'Email': ' elena.fiorindo@confcom.it', 'Password': 'mM/8SkS)OTon2m2B' },
        { 'FirstName': 'Elena Maria', 'LastName': ' Perisotto', 'Email': ' elenamaria.perisotto@confcom.it', 'Password': 'HQ7R%Va?vlTxKfIg' },
        { 'FirstName': 'Eleonora', 'LastName': ' Sandron', 'Email': ' eleonora.sandron@confcom.it', 'Password': ' mm$Y?&sh%*jcs#i' },
        { 'FirstName': 'Elisa', 'LastName': ' Gasparon', 'Email': ' elisa.gasparon@confcom.it', 'Password': '/fbbQsSH=biDw#4' },
        { 'FirstName': 'Elisa', 'LastName': ' Granzotto', 'Email': ' elisa.granzotto@confcom.it', 'Password': '3O*1_1WBA)tQZTQE' },
        { 'FirstName': 'Elisa', 'LastName': ' Granzotto', 'Email': ' elisa.granzotto@confcom.it', 'Password': 'rBnDe_=gh-Y&)P9a' },
        { 'FirstName': 'Elisabetta', 'LastName': ' Seno','Email': ' elisabetta.seno@confcom.it', 'Password': ' z*JYCa#_VnRO/LuD' },
        { 'FirstName': 'Emanuela', 'LastName': ' Spadotto', 'Email': ' emanuela.spadotto@confcom.it', 'Password': '&X7_F7oLu#lG*Se' },
        { 'FirstName': 'Ennio', 'LastName': ' Mezzalira', 'Email': ' ennio.mezzalira@confcom.it', 'Password': '5RFdz5dG-HaRH*3' },
        { 'FirstName': 'Enrica', 'LastName': ' Pagagnin', 'Email': ' enrica.pagagnin@confcom.it', 'Password': 'AO5CSg6KQ!aAqKc3' },
        { 'FirstName': 'Fabrizia', 'LastName': ' Colomba', 'Email': ' fabrizia.colomba@confcom.it', 'Password': ' WPJZnYPtJp?/bp(X' },
        { 'FirstName': 'Federica', 'LastName': ' Zolli', 'Email': ' federica.zolli@confcom.it', 'Password': 'YSK*sx9!SLFGTrL' },
        { 'FirstName': 'Ferruccio', 'LastName': ' Piccoli', 'Email': ' ferruccio.piccoli@confcom.it', 'Password': 'v55mmMEc9Hqle2)U' },
        { 'FirstName': 'Fiorenza', 'LastName': ' Lunardelli', 'Email': ' fiorenza.lunardelli@confcom.it', 'Password': 'j%Ip+1rIcJyz8N7-' },
        { 'FirstName': 'Francesca', 'LastName': ' Renda', 'Email': ' francesca.renda@confcom.it', 'Password': 'DZtE82(SLDAD73K' },
        { 'FirstName': 'Francesca', 'LastName': ' Pasini', 'Email': ' francesca.pasini@confcom.it', 'Password': '86hu7VcO/xgv&1Lw' },
        { 'FirstName': 'Francesco', 'LastName': ' Antonich', 'Email': ' francesco.antonich@confcom.it', 'Password': 'n2#i1w1ATAUiJ(Ip' },
        { 'FirstName': 'Giorgia', 'LastName': ' Montagner', 'Email': ' giorgia.montagner@confcom.it', 'Password': 'BMbMU$(BdGS5(?1z' },
        { 'FirstName': 'Giorgia', 'LastName': ' Rossi', 'Email': ' giorgia.rossi@confcom.it', 'Password': 'R2fuaxND0a1LKL0c' },
        { 'FirstName': 'Giorgio', 'LastName': ' Tiozzo', 'Email': ' giorgio.tiozzo@confcom.it', 'Password': 'TCTT4HPICZ_NGWqT' },
        { 'FirstName': 'Giovanna', 'LastName': ' Dalla Pria', 'Email': ' giovanna.dallapria@confcom.it', 'Password': 'iIYT*H4Ra&vKA13H' },
        { 'FirstName': 'Giulia', 'LastName': ' Pecorelli', 'Email': ' giulia.pecorelli@confcom.it', 'Password': 'ERr&Cm!9i+LrRf#h' },
        { 'FirstName': 'Gloria', 'LastName': ' Barbiero', 'Email': ' gloria.barbiero@confcom.it', 'Password': '$LKZA+C7Sn8uT#W' },
        { 'FirstName': 'Ilaria', 'LastName': ' Babbo', 'Email': ' ilaria.babbo@confcom.it', 'Password': '?FQs$s=UG/!r6etf' },
        { 'FirstName': 'Irene', 'LastName': ' Carrer', 'Email': ' irene.carrer@confcom.it', 'Password': ' !?+ODkCYS_&PGHaL' },
        { 'FirstName': 'Katia', 'LastName': ' Brunello', 'Email': ' katia.brunello@confcom.it', 'Password': '9Dl-L&M4zvb3La9' },
        { 'FirstName': 'Ketty', 'LastName': ' Rossi', 'Email': ' ketty.rossi@confcom.it', 'Password': '6/mTJ=!LLXCk&+Bv' },
        { 'FirstName': 'Lara', 'LastName': ' Bettetto', 'Email': ' lara.bettetto@confcom.it', 'Password': 'H@q1ZX!$rPz%Kdv-' },
        { 'FirstName': 'Laura', 'LastName': ' Greco', 'Email': ' laura.greco@confcom.it', 'Password': 'M6ZmA1k22Cd6FoK' },
        { 'FirstName': 'Laura', 'LastName': ' Bincoletto', 'Email': ' laura.bincoletto@confcom.it', 'Password': '_2cjwuX2X#30la&%' },
        { 'FirstName': 'Laura', 'LastName': ' Stramazzo', 'Email': ' laura.stramazzo@confcom.it', 'Password': 't16pbSoco(Qr8PXF' },
        { 'FirstName': 'Laura', 'LastName': ' Talon', 'Email': ' laura.talon@confcom.it', 'Password': 'X-ZO(u!K%hP00l2/' },
        { 'FirstName': 'Laura', 'LastName': ' Mazzaro', 'Email': ' laura.mazzaro@confcom.it', 'Password': ' ud?=MR+WU?pG/pE' },
        { 'FirstName': 'Laura', 'LastName': ' Donadonibus', 'Email': ' laura.donadonibus@confcom.it', 'Password': '77&vrkrz?+Jt+WZB' },
        { 'FirstName': 'Luca', 'LastName': ' Finotello', 'Email': ' luca.finotello@confcom.it', 'Password': 'j(+MCg!idy5=?Os_' },
        { 'FirstName': 'Luigina Adriana', 'LastName': ' Biondo', 'Email': ' luiginaadriana.biondo@confcom.it', 'Password': '$n1VpDtY)miCa9Aw' },
        { 'FirstName': 'Luisa', 'LastName': ' Cicutto', 'Email': ' luisa.cicutto@confcom.it', 'Password': '#y*Bbld=3GQlQjp' },
        { 'FirstName': 'Manuela', 'LastName': ' Bon', 'Email': ' manuela.bon@confcom.it', 'Password': 'hGQi*p$&/L8H3M$Q'},
        { 'FirstName': 'Mara', 'LastName': ' Agnolin', 'Email': ' mara.agnolin@confcom.it', 'Password': 'JhjwGxI46wNLyThj' },
        { 'FirstName': 'Marcella', 'LastName': ' Fedalto', 'Email': ' marcella.fedalto@confcom.it', 'Password': 'HsvSs8d+r?hvdsXZ' },
        { 'FirstName': 'Maria', 'LastName': ' Puppoli', 'Email': ' maria.puppoli@confcom.it', 'Password': '-3pr#e2lDVoo9DKI' },
        { 'FirstName': 'Maria Pia', 'LastName': ' Milan', 'Email': ' mariapia.milan@confcom.it', 'Password': 'q_OQ(vJg-Yr5CbIe' },
        { 'FirstName': 'Maria Pia', 'LastName': ' Milan', 'Email': ' mariapia.milan@confcom.it', 'Password': '2hJVi#EkemDAi3oW' },
        { 'FirstName': 'Mariaangela', 'LastName': ' Saccone', 'Email': ' mariaangela.saccone@confcom.it', 'Password': 'ZM#*7AGH64hWQ=cu'},
        { 'FirstName': 'Mario','LastName': ' Ranaldi', 'Email': ' mario.ranaldi@confcom.it', 'Password': ' x*Tts?w*t@Erhqn('},
        { 'FirstName': 'Martina', 'LastName': ' Pavan', 'Email': ' martina.pavan@confcom.it', 'Password': 'Gj9(l$ZEbvD*pMW='},
        { 'FirstName': 'Martina','LastName': ' Drigo', 'Email': ' martina.drigo@confcom.it', 'Password': 'yedcfAML&HsS64L' },
        { 'FirstName': 'Massimo', 'LastName': ' Zanon', 'Email': ' massimo.zanon@confcom.it', 'Password': 'cpS10dBqAGR!3q9R' },
        { 'FirstName': 'Matteo', 'LastName': ' Antonich', 'Email': ' matteo.antonich@confcom.it', 'Password': '2=mA?pFMyG6+j$zV' },
        { 'FirstName': 'Michela', 'LastName': ' Rosada', 'Email': ' michela.rosada@confcom.it', 'Password': 'CCor&TXR$S8S?6' },
        { 'FirstName': 'Michela', 'LastName': ' Barban', 'Email': ' michela.barban@confcom.it', 'Password': 'JlPtRzzc!m8q4FL+' },
        { 'FirstName': 'Michela', 'LastName': ' Fragona', 'Email': ' michela.fragona@confcom.it', 'Password': 'F/b_2ri08ZEAfbX' },
        { 'FirstName': 'Michela', 'LastName': ' Patron', 'Email': ' michela.patron@confcom.it', 'Password': '!&s57&tY&Iw6gOBy' },
        { 'FirstName': 'Mirco', 'LastName': ' Crosera', 'Email': ' mirco.crosera@confcom.it', 'Password': ' AdV=W-Fg*Iv=$atR' },
        { 'FirstName': 'Monia', 'LastName': ' Tosetto', 'Email': ' monia.tosetto@confcom.it', 'Password': 'YNUXGfV2P)ske6R)' },
        { 'FirstName': 'Monia', 'LastName': ' De Zotti', 'Email': ' monia.dezotti@confcom.it', 'Password': ' pHvOs/iSGSpadtIe' },
        { 'FirstName': 'Monica', 'LastName': ' Moro', 'Email': ' monica.moro@confcom.it', 'Password': 'U&G+zqP9Qxn*D9XU' },
        { 'FirstName': 'Morena', 'LastName': ' Gazzato', 'Email': ' morena.gazzato@confcom.it', 'Password': 'FtnQBuvIuR0!dCfF' },
        { 'FirstName': 'Noemi', 'LastName': ' Simonini', 'Email': ' noemi.simonini@confcom.it', 'Password': 'u8AKjjmMH9jEXL/a' },
        { 'FirstName': 'Paola', 'LastName': ' Mendolia', 'Email': ' paola.mendolia@confcom.it', 'Password': ' OsZmSHaGl$Bx_PFP' },
        { 'FirstName': 'PAOLO', 'LastName': ' VERONESE', 'Email': ' paolo.veronese@confcom.it', 'Password': '6c7R)$-m?Rp=)*F' },
        { 'FirstName': 'Patrizia', 'LastName': ' Gallo', 'Email': ' patrizia.gallo@confcom.it', 'Password': ' uwH#HUn%?!J#MPTb' },
        { 'FirstName': 'Patrizia', 'LastName': ' Ariani', 'Email': ' patrizia.ariani@confcom.it', 'Password': ' gW@RIGZV%Vb-H*%Y' },
        { 'FirstName': 'Patrizia', 'LastName': ' Moretti', 'Email': ' patrizia.moretti@confcom.it', 'Password': 'j-UoX8d5BS+1cMB_' },
        { 'FirstName': 'Piera', 'LastName': ' Fazzini', 'Email': ' piera.fazzini@confcom.it', 'Password': 'bv#RvzaO60FvSOR' },
        { 'FirstName': 'Pierenza', 'LastName': ' Frasson', 'Email': ' pierenza.frasson@confcom.it','Password': 'dgYJ6!5%EjO0IOuN' },
        { 'FirstName': 'Pierpaolo', 'LastName': " Dall'Agnola", 'Email': " pierpaolo.dall'agnola@confcom.it", 'Password': '-WVINw*MT?4hQyb=' },
        { 'FirstName': 'Rachele', 'LastName': ' Viotto', 'Email': ' rachele.viotto@confcom.it', 'Password': 'zil8afaysVkTn+Gt' },
        { 'FirstName': 'Renata', 'LastName': ' Babbo', 'Email': ' renata.babbo@confcom.it', 'Password': 'WGc6w9K9jl29Y-uF' },
        { 'FirstName': 'Riccardo', 'LastName': ' Germoglio', 'Email': ' riccardo.germoglio@confcom.it', 'Password': '91k(A8Z)T3/hRAU0' },
        { 'FirstName': 'Robert', 'LastName': ' Tomba', 'Email': ' robert.tomba@confcom.it', 'Password': ' eI=nAgY+fptYo$PI' },
        { 'FirstName': 'Roberta', 'LastName': ' Peron', 'Email': ' roberta.peron@confcom.it', 'Password': '*_lfEqs/Wm+6Pir+' },
        { 'FirstName': 'Roberta', 'LastName': ' Borin', 'Email': ' roberta.borin@confcom.it', 'Password': 'ytb7iVrhr@N3eWKy' },
        { 'FirstName': 'Roberta', 'LastName': ' Battiston', 'Email': ' roberta.battiston@confcom.it', 'Password': '-1Kjbtw1!%Jl2WzJ' },
        { 'FirstName': 'Roberta', 'LastName': ' Bellio', 'Email': ' roberta.bellio@confcom.it', 'Password': 'Ff3s=tDby_xk-HF2' },
        { 'FirstName': 'Roberto', 'LastName': ' Campici', 'Email': ' roberto.campici@confcom.it', 'Password': 'RFUKG?ZLbJ!d?0eR' },
        { 'FirstName': 'Rosina', 'LastName': ' Boscolo', 'Email': ' rosina.boscolo@confcom.it', 'Password': 'nqOdAuWhy#p1pcqa' },
        { 'FirstName': 'Rossella', 'LastName': ' Merli', 'Email': ' rossella.merli@confcom.it', 'Password': ' bufqJfeAY-@ggIdg' },
        { 'FirstName': 'Ruggero', 'LastName': ' Franzo', 'Email': ' ruggero.franzo@confcom.it', 'Password': 'Q%5K2wQIq?+e%f`-' },
        { 'FirstName': 'Sandro', 'LastName': ' Bevilacqua', 'Email': ' sandro.bevilacqua@confcom.it', 'Password': 'SSz-iViBp#6r+1Yw' },
        { 'FirstName': 'Savina', 'LastName': ' Furlanetto', 'Email': ' savina.furlanetto@confcom.it', 'Password': '9yRoZ_zaO%qYNe@y' },
        { 'FirstName': 'Sedania', 'LastName': ' Bergamo', 'Email': ' sedania.bergamo@confcom.it', 'Password': ' QrKKe#+ncPT_-//c' },
        { 'FirstName': 'Serena', 'LastName': ' Fattori', 'Email': ' serena.fattori@confcom.it', 'Password': 'rQH@slpLa7*l=(zg' },
        { 'FirstName': 'Serena', 'LastName': ' Fiorindo', 'Email': ' serena.fiorindo@confcom.it', 'Password': 'gy!Zd-33tkH&g!i!' },
        { 'FirstName': 'Sergio', 'LastName': ' Stocco', 'Email': ' sergio.stocco@confcom.it', 'Password': ' EK@JB)*VAYcMvL/b' },
        { 'FirstName': 'Silvia', 'LastName': 'Anese', 'Email': 'silvia.anese@confcom.it', 'Password': ' zI-&eZ+Iy(tcHtG!'},
        { 'FirstName': 'Silvia','LastName': 'Quintavalle','Email': 'silvia.quintavalle@confcom.it','Password': 'Vw@&6)bY7Z0Z?ecA'},
        { 'FirstName': 'Sonia','LastName': 'Meggiato','Email': 'sonia.meggiato@confcom.it','Password': 'wek*fcHoF3xO5uU'},
        { 'FirstName': 'Sonia','LastName': 'Bailo','Email': 'sonia.bailo@confcom.it','Password': 'W8YLliIT$W6hPGrq'},
        { 'FirstName': 'Stefania','LastName': 'Orsini','Email': 'stefania.orsini@confcom.it','Password': '+dcZSWixmIWvvaWz'},
        { 'FirstName': 'Stefania','LastName': 'Busatto','Email': 'stefania.busatto@confcom.it','Password': 'Rhzy?I@m00k9kWdV'},
        { 'FirstName': 'Stefania','LastName': 'Semenzato','Email': 'stefania.semenzato@confcom.it','Password': 'SvH6/N%h-/aGQfcD'},
        { 'FirstName': 'Stefano','LastName': 'Tegon','Email': 'stefano.tegon@confcom.it','Password': 'tlcMLk3sh?Z*6Me&'},
        { 'FirstName': 'Tamara','LastName': 'Bardin','Email': 'tamara.bardin@confcom.it','Password': 'Y+*PH86awJbZy?Bg'},
        { 'FirstName': 'Tiziano','LastName': 'Bondi','Email': 'tiziano.bondi@confcom.it','Password': 'OxH)!b2A&(daFA$@' },
        { 'FirstName': 'Tiziano','LastName': 'Minuzzo','Email': 'tiziano.minuzzo@confcom.it','Password': 'qhChHRV*pLd1JXjz'},
        { 'FirstName': 'Trevisan','LastName': 'Valentina','Email': 'trevisan.valentina@confcom.it','Password': 'T9L5LR#GS_QomE)n'},
        { 'FirstName': 'Utente','LastName': ' API','Email': 'utente.api@confcom.it','Password': 'MR+)3W8_BIzepNAV'},
        { 'FirstName': 'Valentina', 'LastName': ' Padovese', 'Email': 'valentina.padovese@confcom.it','Password': 'Nio/64Megpa9ELF1'},
        { 'FirstName': 'Vanessa','LastName': ' Pulliero','Email': 'vanessa.pulliero@confcom.it', 'Password': 'dH*h*i+yLY=Y8C8q' },
        { 'FirstName': 'Vanni','LastName': ' Boscolo','Email': 'vanni.boscolo@confcom.it','Password': 'D6DbX@-k9EX=XXkn'},
        { 'FirstName': 'Zara','LastName': ' Camillo','Email': 'zara.camillo@confcom.it','Password': 'Gq+lDC*fNEqa#%8P'}
        
        ],
      header:{
        headers: {
            "Content-type": "application/json",
        }
      },
      urlRichieste: "https://sviluppoallergeni.confcom.it/",//'https://apiintranet.confcom.it/'
    };
  },

  methods: {
    // scriptCreaUtenti: async function() {
    //   let errore = 0;
    //   for (let i = 0; i < this.creareUtenti.length; ++i) {
    //     let username = this.creareUtenti[i].FirstName.toLowerCase().replace(/\s+/g, '') + '.' + this.creareUtenti[i].LastName.toLowerCase().replace(/\s+/g, '');
    //     let data = { EMAIL: this.creareUtenti[i].Email.replace(/\s+/g, ''), USERNAME: username, PASSWORD: this.creareUtenti[i].Password.replace(/\s+/g, ''), NOME: this.creareUtenti[i].FirstName, COGNOME: this.creareUtenti[i].LastName.replace(/\s+/g, ''), LIVELLO: 3 };
    //     console.log(`data`);
    //     console.log(data);
    //     await AmministrazioneServices.cretateUsers(data)
    //     .then(response => { this.createUser_response = response.data})
    //     .catch( function (error) {
    //         if(error.response.status == 401){
    //           errore = error.response.status;
    //         }
    //       });
    //     if (errore == 401) {
    //       let value = await this.refreshToken();
    //       if (value) { await this.createUser(); }
    //     }
    //     alert(`Utente creato[${i}] = ${username}`);
    //   }
    // },

    checkData: function() {
      if (this.create_email != null && this.create_username != null && this.create_name != null && this.create_surname != null && this.create_password != null && this.create_level != null) {
        return true;
      } else {
        return false;
      }
    },

    createUser: async function() {
      if (this.checkData()){
        let data = { EMAIL: this.create_email, USERNAME: this.create_username, PASSWORD: this.create_password, NOME: this.create_name, COGNOME: this.create_surname, LIVELLO: this.create_level };
        const token = localStorage.getItem('access_token');
        let errore = 0;
        await AmministrazioneServices.cretateUsers(data)
        // await axios.post(
        //   this.urlRichieste + 'users', data,
        //   {
        //   withCredentials: true,
        //   headers: {
        //     "Content-type": "application/json",
        //     'Authorization': `Bearer ${token}`
        //   }
        // }
        // )
        .then(response => { this.createUser_response = response.data})
        .catch( function (error) {
            if(error.response.status == 401){
              errore = error.response.status;
            }
          });
        if (errore == 401) {
          let value = await this.refreshToken();
          if (value) { await this.createUser(); }
        }
        alert("Utente creato");
      } else {
       // alert("Tutti i campi devono essere compilati!")
       this.showCheckData = true;
      }
    },

    cancelCheckData: function() {
      this.showCheckData = false;
    },

    getUsers: async function() {
      let errore = 0;
      const token = localStorage.getItem('access_token');
      await AmministrazioneServices.getUsers()
      // await axios.get(
      //   this.urlRichieste + 'users',
      //     {
      //     withCredentials: true,
      //     headers: {
      //       "Content-type": "application/json",
      //       'Authorization': `Bearer ${token}`
      //     }
      //   }
      //   )
      .then(response => { this.allUsers = response.data})
      .catch( function (error) {
        if(error.response.status == 401){
          errore = error.response.status;
        }
      });
      if (errore == 401) {
        let value = await this.refreshToken();
        if (value) { await this.getUsers(); }
      }
      console.log("allUsers: ");
      console.log(this.allUsers);

      for (let i = 0; i < this.allUsers.length; ++i) {
        if (this.allUsers[i].LIVELLO == 1) {
          this.level1_users.push(this.allUsers[i]);
        } else if (this.allUsers[i].LIVELLO == 2) {
          this.level2_users.push(this.allUsers[i]);
        } else if (this.allUsers[i].LIVELLO == 3) {
          this.level3_users.push(this.allUsers[i]);
        } else if (this.allUsers[i].LIVELLO == 4) {
          this.level4_users.push(this.allUsers[i]);
        } else {
          this.level5_users.push(this.allUsers[i]);
        }
      }
    },

    getSedi: async function() {
      let errore = 0;
      const token = localStorage.getItem('access_token');
      await Services.getSedi()
      // await axios.get(
      //   'https://apiintranet.confcom.it/users/sede',
      //     {
      //     withCredentials: true,
      //     headers: {
      //       "Content-type": "application/json",
      //       'Authorization': `Bearer ${token}`
      //     }
      //   }
      //   )
      .then(response => { this.allSedi = response.data})
      .catch(function (error) {
        if(error.response.status == 401){
          errore = error.response.status;
        }
      });
      if (errore == 401) {
        let value = await this.refreshToken();
        if (value) { await this.getSedi(); }
      }
      console.log("allSedi:");
      console.log(this.allSedi);
    },

    //TODO
    getUserInfo: async function(id) {
      let errore = 0;
      const token = localStorage.getItem('access_token');
      //let id;
      await AmministrazioneServices.getUserInfo(id)
      // await axios.get(
      //   'https://apiintranet.confcom.it/users/' + id,
      //     {
      //     withCredentials: true,
      //     headers: {
      //       "Content-type": "application/json",
      //       'Authorization': `Bearer ${token}`
      //     }
      //   }
      //   )
      .then(response => { this.infoUtente = response.data})
      .catch( function (error) {
        if(error.response.status == 401){
          errore = error.response.status;
        }
      });
      if (errore == 401) {
        let value = await this.refreshToken();
        if (value) { await this.getSedi(); }
      }
      this.email = this.infoUtente.EMAIL;
      this.level = this.infoUtente.LIVELLO;
      this.username = this.infoUtente.USERNAME;
      this.name = this.infoUtente.NOME;
      this.surname = this.infoUtente.COGNOME;
      this.sede = this.infoUtente.SEDE;
      console.log("infoUtente:");
      console.log(this.infoUtente);
    },

    checkUpdateData() {
      if (this.email != null && this.username != null && this.name != null && this.surname != null && this.password != null && this.level != null) {
        return true;
      } else {
        return false;
      }
    },

    updateInfoUser: async function() {
      let errore = 0;
      const token = localStorage.getItem('access_token');
      let id;
      if (!this.checkUpdateData()) {
        this.showCheckData = true;
      } else {
        await AmministrazioneServices.updateInfoUser(id)
        // await axios.put(
        //   'https://apiintranet.confcom.it/users/' + id,
        //   {
        //   withCredentials: true,
        //   headers: {
        //     "Content-type": "application/json",
        //     'Authorization': `Bearer ${token}`
        //   }
        // }
        // )
        .catch( function (error) {
          if(error.response.status == 401){
            errore = error.response.status;
          }
        });
      if (errore == 401) {
        let value = await this.refreshToken();
        if (value) { await this.updateInfoUser(); }
      }
      alert("Informazioni aggiornate");
      }
    },

    logout: async function() {
      let token = localStorage.getItem("access_token");
      await Services.logout()
      // await axios.delete(
      //   this.urlRichieste + "logout",
      //   //'https://sviluppoallergeni.confcom.it/logout',
      //     {
      //     withCredentials: true,
      //     headers: {
      //        "Content-type": "application/json",
      //       //'Authorization': `Bearer ${token}`
      //     }
      //   }
      // )
      .then(response => { this.results = response.data})
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.setItem('isLogged', false);
      localStorage.removeItem('user_nome')
      localStorage.removeItem('user_cognome');
      localStorage.removeItem('user_tipologia');
      localStorage.removeItem('user_email');
      localStorage.removeItem('user_livello');
      localStorage.removeItem('user_id');
      this.$router.push({
        path: "/login"
      })
    },

    refreshToken: async function() {
      let errore = 0;
      await Services.refreshToken()
      // await axios.post(
      //   this.urlRichieste + "token",
      //   {
      //     withCredentials: true,
      //     headers: {
      //        "Content-type": "application/json",
      //     }
      //   }
      // )
      .then(response => { this.token_response = response.data})
      .catch(function (error) {
         // handle error
        if(error.response.status == 403){
          errore = error.response.status;
        } else if (error.response.status == 401) {
          errore = error.response.status;
        }
      })
      if (errore == 403 || errore == 401) {
        await this.logout();
        return false;
      }
      localStorage.setItem('access_token', this.token_response.accessToken);
      return true;
    },

    main: async function() {
      axios.defaults.withCredentials = true;
      this.user_livello = localStorage.getItem('user_livello');
      try {
        await this.getUsers();
        await this.getSedi();
      } catch (error) {
        if (error.response.status == 401) {
          await this.refreshToken();
        }
      }
    },

  },

  mounted() {
    this.main();
  },

  computed:{},
};
</script>
<style scoped>
body {
  font-family: Roboto, sans-serif;
}
button, input, optgroup, select, textarea {
  font-family: Roboto, sans-serif;
}

.info-button {
  background-color: white; /* Green */
  border: none;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 18px;
  cursor: pointer;
  border-radius: 45%;
}

.row-color:hover {
  background-color: #00467f53;
}
</style>
